import { render } from "./Login_Isda.vue?vue&type=template&id=38a32a2a"
import script from "./Login_Isda.vue?vue&type=script&lang=js"
export * from "./Login_Isda.vue?vue&type=script&lang=js"

import "./Login_Isda.vue?vue&type=style&index=0&id=38a32a2a&lang=less"
script.render = render

export default script